export function Disclaimer() {
  return (
    <div className="border-t border-border mt-10 py-6 text-center" data-testid="disclaimer">
      <p className="text-xs text-muted-foreground max-w-2xl mx-auto px-4 leading-relaxed">
        Market data is provided for informational purposes only. Rates and prices may be delayed or
        inaccurate. This application is not financial, investment, or trading advice.
      </p>
      <p className="text-[10px] text-muted-foreground/70 mt-2 uppercase tracking-wider">
        Currency data: ExchangeRate-API &amp; Frankfurter (ECB) · Crypto data: CoinGecko
      </p>
    </div>
  );
}
